<ng-container [ngSwitch]="kind">
  <!-- FRONT: the side with the photo (pulses to draw the eye) -->
  <div class="ilustracao" aria-hidden="true" *ngSwitchCase="'frente'">
    <div class="cartao frente">
      <div class="foto">
        <svg viewBox="0 0 40 44" class="silhueta">
          <circle cx="20" cy="15" r="9" />
          <path d="M4 44c0-9 7-15 16-15s16 6 16 15z" />
        </svg>
        <span class="anel"></span>
      </div>
      <div class="linhas">
        <span class="ln w70"></span>
        <span class="ln w90"></span>
        <span class="ln w50"></span>
        <span class="ln w80"></span>
      </div>
    </div>
    <p class="legenda-ilu">A <b>frente</b> é o lado com a sua <b>foto</b>.</p>
  </div>

  <!-- BACK: the other side — a card that flips front → back continuously -->
  <div class="ilustracao" aria-hidden="true" *ngSwitchCase="'verso'">
    <div class="cena">
      <div class="vira">
        <div class="cartao face frente">
          <div class="foto">
            <svg viewBox="0 0 40 44" class="silhueta">
              <circle cx="20" cy="15" r="9" />
              <path d="M4 44c0-9 7-15 16-15s16 6 16 15z" />
            </svg>
          </div>
          <div class="linhas">
            <span class="ln w70"></span>
            <span class="ln w90"></span>
            <span class="ln w50"></span>
          </div>
        </div>
        <div class="cartao face verso">
          <div class="linhas full">
            <span class="ln w80"></span>
            <span class="ln w60"></span>
            <span class="ln w90"></span>
            <span class="ln w40"></span>
          </div>
          <svg class="mini-qr" [attr.viewBox]="'0 0 ' + qrN + ' ' + qrN" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
            <rect [attr.width]="qrN" [attr.height]="qrN" fill="#fff"></rect>
            <rect *ngFor="let m of qrModules" [attr.x]="m.x" [attr.y]="m.y" width="1" height="1" fill="#1a1a1a"></rect>
          </svg>
        </div>
      </div>
    </div>
    <p class="legenda-ilu">O <b>verso</b> é o <b>outro lado</b>, atrás do documento.</p>
  </div>

  <!-- QR: a large, dense code like the real one, with a scan sweep -->
  <div class="ilustracao" aria-hidden="true" *ngSwitchCase="'qr'">
    <div class="qr-grande">
      <svg class="qr-svg" [attr.viewBox]="'0 0 ' + qrN + ' ' + qrN" preserveAspectRatio="xMidYMid meet">
        <rect [attr.width]="qrN" [attr.height]="qrN" fill="#fff"></rect>
        <rect *ngFor="let m of qrModules" [attr.x]="m.x" [attr.y]="m.y" width="1" height="1" fill="#1a1a1a"></rect>
      </svg>
      <span class="varredura"></span>
    </div>
    <p class="legenda-ilu">O <b>QR</b> é o <b>quadrado</b> cheio de pontinhos.</p>
  </div>

  <!-- CNH-ABRIR: guided GIF ("CNH abrindo") — starts on the front (photo) and ends
       with the document open on the QR page. Shown on the focused live-QR step so the
       user knows to open the CNH and show the QR inside. -->
  <div class="ilustracao ilustracao-gif" *ngSwitchCase="'cnh-abrir'">
    <img
      class="gif-ilu"
      src="assets/img/gif-cnh-qrcode.gif"
      alt="Abra a CNH e mostre a página do QR code"
    />
    <p class="legenda-ilu">O <b>QR</b> (<b>quadrado</b> cheio de pontinhos) fica <b>dentro</b> da CNH.</p>
  </div>

  <!-- CNH-VERSO: guided GIF ("CNH girando") — starts on the front (photo) and rotates
       to the OUTER back, the vehicle-categories side with the observations box. This is
       the surface Veriff verifies as `document-back`; the GIF + caption stop users from
       handing us the inner QR page instead. -->
  <div class="ilustracao ilustracao-gif" *ngSwitchCase="'cnh-verso'">
    <img
      class="gif-ilu"
      src="assets/img/gif-cnh-verso.gif"
      alt="Vire a CNH para o verso, o lado das categorias (A, B, C…)"
    />
    <p class="legenda-ilu">
      O <b>verso</b> é o lado das <b>categorias</b> (A, B, C…), com o documento <b>fechado</b>.
      <b>Não</b> é a parte do QR.
    </p>
  </div>

  <!-- CNH-INTERNA: guided GIF ("CNH abrindo") — the folded document's INNER page, the
       QR/MRZ surface reached by opening it. Read for its signed data; never sent as the
       back. Same "open to the QR" motion as cnh-abrir, shown on the inner-page photo step. -->
  <div class="ilustracao ilustracao-gif" *ngSwitchCase="'cnh-interna'">
    <img
      class="gif-ilu"
      src="assets/img/gif-cnh-qrcode.gif"
      alt="Abra a CNH e mostre a página do QR code"
    />
    <p class="legenda-ilu"><b>Abra</b> o documento e <b>vire</b>: a página do <b>QR</b> fica <b>dentro</b>.</p>
  </div>

  <!-- VERSO-AMOSTRA: a static, generic "back of document" sample (no real doc, no PII) -->
  <div class="ilustracao" aria-hidden="true" *ngSwitchCase="'verso-amostra'">
    <div class="cartao verso-amostra">
      <div class="linhas full">
        <span class="ln w80"></span>
        <span class="ln w60"></span>
        <span class="ln w90"></span>
      </div>
      <div class="assinatura">
        <svg viewBox="0 0 120 24" class="rubrica" preserveAspectRatio="none" aria-hidden="true">
          <path d="M4 16c8-12 14 6 22-2s10 8 18 0 12 6 22-4 16 8 26 2" />
        </svg>
      </div>
      <div class="mrz">
        <span class="mrz-linha"></span>
        <span class="mrz-linha"></span>
      </div>
    </div>
    <p class="legenda-ilu">Fotografe o <b>verso</b> (o outro lado) do documento.</p>
  </div>
</ng-container>
